// src/components/ConfigurationHealthCheck.js
import React, { useState, useEffect } from 'react';
import StatusBadge from './StatusBadge';

const API_BASE_URL = window.location.hostname === 'localhost' ? 'http://localhost:7071' : '';

// --- 'StatusIcon' component removed ---
// The linter was correct, it was not being used.

function ConfigurationHealthCheck() {
    const [healthStatus, setHealthStatus] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchHealthStatus = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/diagnostics`);
                if (!response.ok) {
                    throw new Error("Failed to fetch health status.");
                }
                const data = await response.json();
                setHealthStatus(data);
            } catch (e) {
                console.error("Health check failed:", e);
                setHealthStatus({ error: "Could not retrieve health status." });
            } finally {
                setIsLoading(false);
            }
        };
        fetchHealthStatus();
    }, []);

    if (isLoading) {
        return <div className="health-check-box"><h4>Configuration Health Status</h4><p>Running checks...</p></div>;
    }

    if (!healthStatus || healthStatus.error) {
        return <div className="health-check-box error"><p>Could not load configuration health status.</p></div>;
    }
    
    // A mapping from the API key to a user-friendly name
    const checkNames = {
        "audit_logs": "Azure AD Audit Logs",
        "signin_logs": "Azure AD Sign-in Logs",
        "office_activity_logs": "Microsoft 365 Activity Logs",
        "graph_api_roles_permission": "Graph API Role Permissions"
    };

    return (
        <div className="health-check-box">
            <h4>Configuration Health Status</h4>
            <ul>
                {Object.entries(checkNames).map(([key, name]) => (
                    <li key={key}>
                        {/* This correctly uses your StatusBadge component */}
                        <StatusBadge label={name} status={healthStatus[key]} />
                        {healthStatus[key] !== 'OK' && <span className="status-detail">({healthStatus[key]})</span>}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default ConfigurationHealthCheck;